import { pctDisplayNumber } from './termSheetFormatters';

function pctOrPlaceholder(value) {
  const pct = pctDisplayNumber(value);
  return pct == null ? '[]' : pct;
}

export function buildCappedReturnIrrLine(fields, getPct = pctOrPlaceholder) {
  const irr = getPct(fields.cappedReturnIrr);
  return `${irr}% per month calculated on the monthly outstanding amount per cohort (see ex. on next pg.), payable from the cohort cash flows`;
}

export function buildCappedReturnTotalFeeLine(fields, getPct = pctOrPlaceholder) {
  const totalFeePerCohort = getPct(fields.cappedReturnTotalFeePerCohort);
  return `This amounts to ~${totalFeePerCohort}% per cohort (see ex.)`;
}

export function buildCappedReturnClause(fields, getPct = pctOrPlaceholder) {
  return [
    `• ${buildCappedReturnIrrLine(fields, getPct)}`,
    `• ${buildCappedReturnTotalFeeLine(fields, getPct)}`,
  ].join('\n\n');
}
